export const textColor = (text, attrs) => {
  return `{color:${attrs.color}}${text}{color}`;
};